import api from '../../utils/api'
import { fetchScoutUserLogout } from '../auth/authActions'
import * as actionTypes from './actionTypes'

/** Sets the scout's confirmed email status */
export const setConfirmedEmail = () => ({
  type: actionTypes.SET_SCOUT_CONFIRMED_EMAIL,
})

/** Marks the save and exit button as clicked */
export const SaveAndExitClicked = data => ({
  type: actionTypes.Save_And_Exit_Clicked,
  payload: data,
})

/** Resets the save and exit button state */
export const SaveAndExitClickedReset = data => ({
  type: actionTypes.Save_And_Exit_Clicked_Reset,
  payload: data,
})

/** Advances to the next step in the flow */
export const nextStep = () => ({
  type: actionTypes.NEXT_STEP,
})

/** Advances to the next scout-specific step */
export const nextStepScout = () => ({
  type: actionTypes.NEXT_STEP_SCOUT,
})

/** Returns to the previous step */
export const prevStep = () => ({
  type: actionTypes.PREV_STEP,
})

/** Returns to the previous scout-specific step */
export const prevStepScout = () => ({
  type: actionTypes.PREV_STEP_SCOUT,
})

/** Resets the scout flow to initial state */
export const initialScoutState = () => ({
  type: actionTypes.RESET_INITIAL_SCOUT_STATE,
})

/** Marks scout signup as failed */
export const scoutSignupFailed = () => ({
  type: actionTypes.SCOUT_SIGNUP_FAILED,
})

/** Marks scout login as failed */
export const scoutLoginFailed = () => ({
  type: actionTypes.SCOUT_LOGIN_FAILED,
})

/** Updates the current scout step */
export const updateScoutStep = stepScout => ({
  type: actionTypes.UPDATE_SCOUT_STEP,
  payload: stepScout,
})

export const updateProfileSettingActiveTabKey = key => ({
  type: actionTypes.CHANGE_SETTINGS_PROFILE_ACTIVE_KEY,
  payload: key,
})

/** Resets the flow to initial state */
export const initialState = () => ({
  type: actionTypes.RESET_INITIAL_STATE,
})

/** Returns to the home page */
export const toggleLogoToHome = () => ({
  type: actionTypes.RETURN_HOME_PAGE,
})

/** Clears all scout profile data */
export const clearScoutProfileData = () => ({
  type: actionTypes.CLEAR_PROFILE_DATA,
})

/** Fetches the scout's profile data */
export const fetchProfileData = () => {
  return async dispatch => {
    dispatch({
      type: actionTypes.FETCH_SCOUT_PROFILE_INIT,
    })
    await api
      .get(`${process.env.REACT_APP_API_URL}/scout/profile-data`, undefined, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.FETCH_SCOUT_PROFILE_SUCCESS,
          payload: res?.data,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.FETCH_SCOUT_PROFILE_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Updates the scout's profile information */
export const editProfileData = (data, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.EDIT_SCOUT_PROFILE_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/scout/profile-data`, { ...data }, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.EDIT_SCOUT_PROFILE_SUCCESS,
          payload: res?.data,
        })
        onSuccess(res?.data)
        // return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.EDIT_SCOUT_PROFILE_FAILED,
        })
        onFail(error?.response?.data?.error)
        throw error?.response?.data?.error
      })
  }
}

/** Uploads a new profile picture for the scout */
export const uploadProfilePicture = (data, onSuccess) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPLOAD_SCOUT_PROFILE_PICTURE_INIT,
    })
    await api
      .postwithFormData(`${process.env.REACT_APP_API_URL}/scout/mime-files`, data, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.UPLOAD_SCOUT_PROFILE_PICTURE_SUCCESS,
          payload: res,
        })
        onSuccess && onSuccess()
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPLOAD_SCOUT_PROFILE_PICTURE_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Updates the scout's password */
export const updatePassword = (data, onSuccess, onError) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_SCOUT_PASSWORD_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/scout/update-password`, { ...data }, 'scout')
      .then(res => {
        if (res?.result) {
          dispatch({
            type: actionTypes.UPDATE_SCOUT_PASSWORD_SUCCESS,
            payload: res?.data,
          })
          onSuccess()
        } else {
          dispatch({
            type: actionTypes.UPDATE_SCOUT_PASSWORD_FAILED,
          })
          onError()
        }
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_SCOUT_PASSWORD_FAILED,
        })
        onError()
        throw error?.response?.error
      })
  }
}

/** Retrieves the scout's email notification settings */
export const getEmailNotifications = onSuccess => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_SCOUT_EMAIL_NOTIFICATIONS_INIT,
    })
    await api
      .get(`${process.env.REACT_APP_API_URL}/scout/email-notification`, undefined, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.GET_SCOUT_EMAIL_NOTIFICATIONS_SUCCESS,
          payload: res?.data,
        })
        onSuccess && onSuccess(res?.data)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_SCOUT_EMAIL_NOTIFICATIONS_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Updates the scout's email notification preferences */
export const setEmailNotifications = (data, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.SET_SCOUT_EMAIL_NOTIFICATIONS_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/scout/email-notification`, data, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.SET_SCOUT_EMAIL_NOTIFICATIONS_SUCCESS,
          payload: res?.data,
        })
        onSuccess && onSuccess(res)
        // return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.SET_SCOUT_EMAIL_NOTIFICATIONS_FAILED,
        })
        onFail && onFail(error?.response?.data?.error || error?.message)
        throw error?.response?.data?.error
      })
  }
}

/** Sends bulk email invites to potential scouts */
export const bultInvite = (data, onSuccess, onError) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.BULK_EMAIL_INVITE_SCOUT_INIT,
    })
    await api
      .postwithFormData(`${process.env.REACT_APP_API_URL}/scout/bulk-invite`, data, 'scout')
      .then(res => {
        if (res?.result) {
          dispatch({
            type: actionTypes.BULK_EMAIL_INVITE_SCOUT_SUCCESS,
            payload: res,
          })
          onSuccess(res?.message)
        } else {
          onError(res?.error)
        }

        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.BULK_EMAIL_INVITE_SCOUT_FAILED,
        })
        onError(error?.response?.error)
        throw error?.response?.error
      })
  }
}

/** Sends an email invite to a potential scout */
export const emailInvite = (data, onSuccess) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.EMAIL_INVITE_SCOUT_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/scout/invite`, data, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.EMAIL_INVITE_SCOUT_SUCCESS,
          payload: res?.data,
        })
        onSuccess(res)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.EMAIL_INVITE_SCOUT_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Retrieves referrals for scout startups */
export const getScoutStartupsReferrals = data => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_SCOUT_STARTUP_REFERRALS_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/scout/referrals`, data, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.GET_SCOUT_STARTUP_REFERRALS_SUCCESS,
          payload: res,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_SCOUT_STARTUP_REFERRALS_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Retrieves referrals for scout investors */
export const getScoutInvestorsReferrals = data => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_SCOUT_INVESTOR_REFERRALS_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/scout/referrals`, data, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.GET_SCOUT_INVESTOR_REFERRALS_SUCCESS,
          payload: res,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_SCOUT_INVESTOR_REFERRALS_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Fetches the count of unread notifications */
export const fetchUnreadNotificationCount = () => {
  return async dispatch => {
    dispatch({
      type: actionTypes.FETCH_SCOUT_UNREAD_NOTIFICATION_COUNT_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/scout/notification-dropdown`, { is_clicked: false }, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.FETCH_SCOUT_UNREAD_NOTIFICATION_COUNT_SUCCESS,
          payload: res,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.FETCH_SCOUT_UNREAD_NOTIFICATION_COUNT_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Fetches all unread notifications */
export const fetchUnreadNotifications = () => {
  return async dispatch => {
    dispatch({
      type: actionTypes.FETCH_SCOUT_UNREAD_NOTIFICATIONS_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/scout/notification-dropdown`, { is_clicked: true }, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.FETCH_SCOUT_UNREAD_NOTIFICATIONS_SUCCESS,
          payload: res,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.FETCH_SCOUT_UNREAD_NOTIFICATIONS_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Clears all scout notifications */
export const clearScoutNotifications = () => {
  return async dispatch => {
    dispatch({
      type: actionTypes.CLEAR_SCOUT_NOTIFICATIONS_INIT,
    })
    await api
      .post(
        `${process.env.REACT_APP_API_URL}/scout/notification-dropdown`,
        { is_clicked: true, clear: true },
        'scout',
      )
      .then(res => {
        dispatch({
          type: actionTypes.CLEAR_SCOUT_NOTIFICATIONS_SUCCESS,
          payload: res,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.CLEAR_SCOUT_NOTIFICATIONS_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Fetches all notifications for the scout */
export const fetchNotifications = data => {
  return async dispatch => {
    dispatch({
      type: actionTypes.FETCH_SCOUT_NOTIFICATIONS_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/scout/notifications`, data, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.FETCH_SCOUT_NOTIFICATIONS_SUCCESS,
          payload: res,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.FETCH_SCOUT_NOTIFICATIONS_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Marks the scout tour as completed */
export const completeScoutTour = () => {
  return async dispatch => {
    dispatch({
      type: actionTypes.COMPLETE_SCOUT_TOUR_INIT,
    })
    await api
      .get(`${process.env.REACT_APP_API_URL}/scout/tour-completed`, undefined, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.COMPLETE_SCOUT_TOUR_SUCCESS,
          payload: res,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.COMPLETE_SCOUT_TOUR_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Resends the email confirmation link */
export const resendEmailConfirmLink = () => {
  return async dispatch => {
    await api
      .get(`${process.env.REACT_APP_API_URL}/scout/email-confirmation-link`, undefined, 'scout')
      .then(res => {
        return
      })
      .catch(error => {
        throw error?.response?.data?.error
      })
  }
}

/** Retrieves the scout's invite history */
export const getScoutInviteHistory = (data, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_INVITE_HISTORY_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/scout/invite-history`, data, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.GET_INVITE_HISTORY_SUCCESS,
          payload: res,
        })
        onSuccess && onSuccess()
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_INVITE_HISTORY_FAILED,
        })
        onFail && onFail()
        throw error?.response?.data?.error
      })
  }
}

/** Sets the scout loader state */
export const setScoutLoader = () => ({
  type: 'SET_SCOUT_LOADER',
})

/** Controls visibility of the scout load button */
export const setHideScoutLoadButton = data => ({
  type: 'SET_HIDE_SCOUT_LOAD_BUTTON',
  payload: data,
})

/** Updates the scout deals list */
export const getScoutDealsList = (data, page, totalCount) => ({
  type: 'GET_SCOUT_DEALS_LIST',
  payload: data,
  page,
  totalCount,
})

/** Updates the scout deals */
export const getScoutDeals = (data, page, totalCount) => ({
  type: 'GET_SCOUT_DEALS',
  payload: data,
  page,
  totalCount,
})

/** Hides the scout loader */
export const setHideScoutLoader = () => ({
  type: 'SET_HIDE_SCOUT_LOADER',
})

/** Fetches deals relevant to the scout */
export const fetchScoutDeals = data => {
  return dispatch => {
    dispatch(setScoutLoader())
    return api
      .post(
        `${process.env.REACT_APP_API_URL}/scout/get-relevant-startups`,
        {
          page_num: data,
          page_size: 10,
        },
        'scout',
      )
      .then(res => {
        if (res.result) {
          if (!res?.data?.length) {
            dispatch(setHideScoutLoadButton(true))
          } else {
            dispatch(setHideScoutLoadButton(false))
          }
          if (data === 1) {
            dispatch(getScoutDealsList(res.data, data + 1, res.total_count))
          } else {
            dispatch(getScoutDeals(res.data, data + 1, res.total_count))
          }
          return res
        } else {
          dispatch(setHideScoutLoader())
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchScoutUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return false
        }
      })
  }
}

/** Clears all scout deals */
export const clearScoutDeals = () => ({
  type: 'CLEAR_SCOUT_DEALS',
})

/** Retrieves the scout's profile information */
export const getScoutProfile = onSuccess => {
  return async dispatch => {
    await api
      .get(`${process.env.REACT_APP_API_URL}/scout/profile-data`, undefined, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes?.FETCH_SCOUT_PROFILE_SUCCESS,
          payload: res.data,
        })
        if (res.result && onSuccess) {
          onSuccess(res)
        }
        return res
      })
      .catch(error => {
        throw error?.response?.data?.error || error?.message
      })
  }
}

/** Retrieves carry entities for the scout */
export const getCarryEntities = (onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_CARRY_ENTITIES_INIT,
    })
    await api
      .get(`${process.env.REACT_APP_API_URL}/scout/get-carry-entities`, undefined, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.GET_CARRY_ENTITIES_SUCCESS,
          payload: res,
        })
        onSuccess && onSuccess(res)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_CARRY_ENTITIES_FAILED,
        })
        onFail && onFail()
        throw error?.response?.data?.error
      })
  }
}

/** Adds a new carry entity */
export const addCarryEntity = (data, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.ADD_CARRY_ENTITY_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/scout/add-carry-entity`, data, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.ADD_CARRY_ENTITY_SUCCESS,
        })
        onSuccess && onSuccess(res)
        // return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.ADD_CARRY_ENTITY_FAILED,
        })
        onFail && onFail()
        throw error?.response?.data?.error
      })
  }
}

/** Sets a carry entity as primary */
export const setPrimaryCarryEntity = (id, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.SET_PRIMARY_CARRY_ENTITY_INIT,
    })
    await api
      .get(
        `${process.env.REACT_APP_API_URL}/scout/set-primary-carry-entity?carry_entity_id=${id}`,
        undefined,
        'scout',
      )
      .then(res => {
        dispatch({
          type: actionTypes.SET_PRIMARY_CARRY_ENTITY_SUCCESS,
        })
        onSuccess && onSuccess(res)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.SET_PRIMARY_CARRY_ENTITY_FAILED,
        })
        onFail && onFail()
        throw error?.response?.data?.error
      })
  }
}

/** Views details of a specific carry entity */
export const viewCarryEntity = (id, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.VIEW_CARRY_ENTITY_INIT,
    })
    await api
      .get(
        `${process.env.REACT_APP_API_URL}/scout/view-carry-entity?carry_entity_id=${id}`,
        undefined,
        'scout',
      )
      .then(res => {
        dispatch({
          type: actionTypes.VIEW_CARRY_ENTITY_SUCCESS,
        })
        onSuccess && onSuccess(res)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.VIEW_CARRY_ENTITY_FAILED,
        })
        onFail && onFail()
        throw error?.response?.data?.error
      })
  }
}

/** Fetches scout contracts */
export const fetchScoutContracts = (data, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.FETCH_SCOUT_CONTRACTS_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/scout/get-contracts`, data, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.FETCH_SCOUT_CONTRACTS_SUCCESS,
          payload: res,
        })
        onSuccess && onSuccess(res)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.FETCH_SCOUT_CONTRACTS_FAILED,
        })
        onFail && onFail()
        throw error?.response?.data?.error
      })
  }
}

/** Signs a contract for the scout */
export const signContractScout = (data, onSuccess) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.SIGN_SCOUT_CONTRACTS_INIT,
    })
    await api
      .postwithFormData(`${process.env.REACT_APP_API_URL}/scout/sign-contract`, data, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.SIGN_SCOUT_CONTRACTS_SUCCESS,
          payload: res,
        })
        onSuccess && onSuccess(res)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.SIGN_SCOUT_CONTRACTS_FAILED,
        })
        throw error?.response?.data?.error
      })
  }
}

/** Uploads a file for a carry entity */
export const carryEntityFileUploader = (data, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.CARRY_ENTITY_FILE_UPLOADER_INIT,
    })
    await api
      .postwithFormData(`${process.env.REACT_APP_API_URL}/scout/carry-entity-file-uploader`, data, 'scout')
      .then(res => {
        dispatch({
          type: actionTypes.CARRY_ENTITY_FILE_UPLOADER_SUCCESS,
          payload: res,
        })
        onSuccess && onSuccess(res)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.CARRY_ENTITY_FILE_UPLOADER_FAILED,
        })
        onFail && onFail(error?.response?.data?.error)
        throw error?.response?.data?.error
      })
  }
}
